// extracted by mini-css-extract-plugin
export default {"container":"News_container__U9YP1","h2":"News_h2__CTL5D","dropdown":"News_dropdown__ADAyv","noresult":"News_noresult__jMax8","anchor":"News_anchor__+spM9"};